import { DateTime } from "luxon";

export const formatDateTime = (datetime) =>
  DateTime.fromISO(datetime).toFormat("yyyy-MM-dd HH:mm");
